/**************************************************
 * Nombre:       Formulario_Zonas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, Flag, Google, PercentOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSUSUARIOS} from "../../Constantes";
import IngresoCheckGrupo from "../../Modulo_formularios/Componentes/IngresoCheckGrupo";

const Formulario_Zonas = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Flag} nombre={'Nombre de la zona'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PercentOutlined} nombre={'Porcentaje'} dato={'valor'} {...props} type={'number'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Zonas